import { FC, ReactNode } from 'react';
import cn from 'classnames';

import { Action } from '../Action';
import { Header, Props as HeaderProps } from './Header';
import style from './ComponentHeader.module.scss';

interface Props extends HeaderProps {
  className?: string;
  mobileActionClassName?: string;
  children: ReactNode;
}

export const ComponentHeader: FC<Props> = (props) => {
  const { className, mobileActionClassName, children, ...rest } = props;
  const { locale, action, actionVariant } = rest;
  return (
    <div className={className}>
      <Header {...rest} />
      {children}
      <Action
        className={cn(style.mobileButton, 'u-m-t-xl', mobileActionClassName)}
        locale={locale}
        variant={actionVariant}
        {...action}
      />
    </div>
  );
};
